export function parseViewsString(views: string): number {
  if (views.includes("亿")) return parseFloat(views) * 1e8;
  if (views.includes("万")) return parseFloat(views) * 1e4;
  return parseFloat(views) || 0;
}

export function formatCount(count: number): string {
  if (count >= 100000000) return `${(count / 100000000).toFixed(1)}亿`;
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  return `${count}`;
}